import _ from 'lodash';

export const ROLE_TYPES = {
    ADMIN: {messageId: 'types.role.admin'},
    ALL: {messageId: 'types.role.all'},
    SUPER_ADMIN: {messageId: 'types.role.superAdmin', disabled: true}
};

export const ROLE_TYPE_OPTIONS = Object.keys(ROLE_TYPES).map(key => _.set(ROLE_TYPES[key], 'key', key.toLowerCase()));


// WEBPACK FOOTER //
// ./src/constants/roleTypes.js